import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Toaster } from './components/Toast';
import './theme/globals.css';
import { bindPress } from './lib/motion';

// The pill press (redesign §1.2, §35): one delegated listener set for the page.
bindPress(document.body);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <Toaster />
  </StrictMode>
);
